import styled from 'styled-components';

const VerticalCentered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 100vh;
`;

export default VerticalCentered;
